export default "__VITE_ASSET__BeKU7JHY__"